import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SettingsResponse } from "./definitions";

const initialState: SettingsResponse = {
  auth: undefined,
  logger: undefined,
  endpoints: {},
  evidently: undefined,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    settingsLoaded: (state, action: PayloadAction<SettingsResponse>) => {
      state.auth = action.payload.auth;
      state.logger = action.payload.logger;
      state.endpoints = action.payload.endpoints;
    },
  },
});

export const { settingsLoaded } = settingsSlice.actions;

export default settingsSlice.reducer;
